import { SelfPublishesState } from './self-publishes.reducer';
import { SelfPublishState } from './self-publish.reducer';
import * as SelfPublishActions from './self-publish.action';
import * as SelfPublishesActions from './self-publishes.actions';

export { selectSelfPublishState } from './self-publish.selectors';
export { selectSelfPublishesState } from './self-publishes.selectors';
export { SelfPublishActions };
export { SelfPublishesActions };

export interface SelfPublishesStore {
  selfPublishes: {
    selfPublish: SelfPublishState;
    selfPublishes: SelfPublishesState;
  };
}
